import React from 'react'
import { Link, useLocation } from 'react-router-dom' // Import useLocation hook
import Group from '../../icons/Group'
import Close from '../../icons/Close'

const menuItems = [
  {
    name: 'Users',
    icon: Group,
    path: '/admin/users',
    color: 'white', // Icon color for active state
  },
]

const Sidebar = ({ isSidebarOpen, toggleSidebar }) => {
  const location = useLocation() // Get the current path

  return (
    <aside
      className={`fixed md:relative inset-y-0 left-0 z-50 w-64 bg-white shadow-md transition-transform duration-300 transform ${
        isSidebarOpen ? 'block' : 'hidden'
      }`}
    >
      <div className="relative">
        <div className="h-20 border-b border-b-[#EAEFF4] flex justify-center items-center">
          <img src="/images/logo.png" alt="Logo" className="w-44" />
        </div>
        <nav className="mt-6 p-4">
          <ul>
            <li className="mb-2">
              <span className="text-grey-500 text-sm">OPERATIONS</span>
            </li>

            {menuItems.map((item) => {
              const IconComponent = item.icon
              const isActive = location.pathname.startsWith(item.path)

              return (
                <li
                  key={item.path}
                  className={`rounded-lg mb-2 ${
                    isActive
                      ? 'bg-primary text-white'
                      : 'bg-white border border-gray-200'
                  }`}
                >
                  <Link
                    to={item.path}
                    className={`p-3 flex gap-2 justify-start items-center ${
                      isActive ? 'text-white' : 'text-black'
                    }`}
                  >
                    <IconComponent
                      size="6"
                      color={isActive ? item.color : 'black'}
                    />
                    {item.name}
                  </Link>
                </li>
              )
            })}
          </ul>
        </nav>

        <button
          onClick={toggleSidebar}
          className="text-white hover:text-gray-900 absolute top-0 right-[-20px] md:hidden"
        >
          <Close color="white" />
        </button>
      </div>
    </aside>
  )
}

export default Sidebar
